import { render, staticRenderFns } from "./ContactLabSoft.vue?vue&type=template&id=5f43cef5&"
import script from "./ContactLabSoft.vue?vue&type=script&lang=js&"
export * from "./ContactLabSoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports